export default {
  runDev: process.env['NODE_ENV'] === 'development',
}
